<div class="info-container">
  <span class="header">{{ header }}</span>
  <span class="value">
    <ng-content></ng-content>
  </span>
</div>
